// queries/oattData.ts
import { gql } from '@apollo/client';

// Query for OATT data by month and year
export const GET_OATT_DATA = gql`
  query GetOattData($month: Int!, $year: Int!, $customerId: Int) {
    oattData(month: $month, year: $year, customerId: $customerId) {
      oatt_data_id
      seller
      aref
      customer_code
      billing_period
      start_time
      stop_time
      mw_granted
      billing_rate
      billing_type
      ts_class
      increment
      ts_type
      ts_window
      hours
      net_trans
      asr_rv_net
      asr_sc_net
      total_charges
    }
  }
`;
export const UPLOAD_OATT_FILES = gql`
  mutation UploadOattFiles($results: [OattUploadResult!]!) {
    uploadOattFiles(results: $results) {
      success
      message
    }
  }
`;

export const GET_OATT_FILE_INGESTION_LOGS = gql`
  query OattFileIngestionLogs {
    oattFileIngestionLogs {
      oattFileIngestionLogs_id
      file_name
      record_count
      status
      month_year
      ingestion_timestamp
      upload_by
      error_message
    }
  }
`;